// @flow

// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Selectors
import { users$, authenticatedUser$ } from 'fc-users'

export default createSelector(
  [
    users$,
    authenticatedUser$,
  ],
  function (users: UsersById, authenticatedUserId: number): Array<User> {
    return _find(users, (user: User): User => user.id === authenticatedUserId)
  }
)
